import styled from 'styled-components'

import { Loader } from '~/ui/Loader'

const Container = styled.div`
  height: 75px;
`

export default function PopoverMenuLoader() {
  return (
    <Container>
      <Loader label="" variant="centered" />
    </Container>
  )
}
